import PageTemplate from "../../../components/feature/PageTemplate";
import { asphaltContent } from "../../../mocks/asphalt-content";

export default function AsphaltPavingPage() {
  return <PageTemplate content={asphaltContent} />;
}
